import { render } from "./ReusableComposition.vue?vue&type=template&id=0d1b3fc1&scoped=true"
import script from "./ReusableComposition.vue?vue&type=script&lang=js"
export * from "./ReusableComposition.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0d1b3fc1"

export default script